// GSAP VIDEO LAZYLOAD
// 2026-10-06: removed the ".lazy-image" loader. It copied the whole srcset string into img.src, so the CDN
// returned full-size originals (~10 MB extra per homepage view). The images already use native
// loading="lazy" with srcset/sizes, which picks the right width on its own.
if (!Shopify.designMode) {
  document.addEventListener("DOMContentLoaded", function() {
    const lazyVideos = document.querySelectorAll(".lazy-video");

    // GSAP ScrollTrigger for each video
    gsap.registerPlugin(ScrollTrigger);
    lazyVideos.forEach(video => {
      const play = () => {
        if (video.dataset.userPaused === "1") return;
        video.muted = true;  // Ensure autoplay compliance
        const p = video.play();
        if (p && p.catch) p.catch(() => {});
      };
      ScrollTrigger.create({
        trigger: video,
        start: "top 50%",  // Adjust as needed
        end: "bottom 20%", // Adjust as needed
        onEnter: play,
        onEnterBack: play,
        onLeave: () => video.pause(),
        onLeaveBack: () => video.pause(),
      });
    });
  });
}

// hp-slideshow
(function ($) {
	"use strict";

	/*=============================================
		=    		 Swiper Slider			      =
	=============================================*/
	if ($('.hatch-pro-slideshow').length) {
		$('.hatch-pro-slideshow').each(function () {
			var SwiperCarousel = $(this);
			var breakpoints = {
				480: { slidesPerView: SwiperCarousel.data('sm-items') || 1, loop: SwiperCarousel.data('sm-loop') || true, autoplay: SwiperCarousel.data('sm-autoplay') || false, spaceBetween: SwiperCarousel.data('sm-space') || 30 },
				640: { slidesPerView: SwiperCarousel.data('md-items') || 1, loop: SwiperCarousel.data('md-loop') || true, autoplay: SwiperCarousel.data('md-autoplay') || false, spaceBetween: SwiperCarousel.data('md-space') || 30 },
				991: { slidesPerView: SwiperCarousel.data('lg-items') || 1, loop: SwiperCarousel.data('lg-loop') || true, autoplay: SwiperCarousel.data('lg-autoplay') || false, spaceBetween: SwiperCarousel.data('lg-space') || 30 },
				1199: { slidesPerView: SwiperCarousel.data('xl-items') || 1, loop: SwiperCarousel.data('xl-loop') || true, autoplay: SwiperCarousel.data('xl-autoplay') || false, spaceBetween: SwiperCarousel.data('xl-space') || 30 }
			};

			var swiper = new Swiper(SwiperCarousel[0], {
				slidesPerView: SwiperCarousel.data('items') || 1,
				loop: SwiperCarousel.data('loop') || true,
				// speed: SwiperCarousel.data('speed') || 600,
				effect: SwiperCarousel.data('effect') || 'fade',
				lazy: SwiperCarousel.data('lazy') || true,
				spaceBetween: SwiperCarousel.data('space') || 30,
				navigation: { nextEl: SwiperCarousel.data('next'), prevEl: SwiperCarousel.data('prev') },
				pagination: { el: SwiperCarousel.data('pagination'), clickable: true, },
				scrollbar: { el: SwiperCarousel.data('scrollbar'), hide: false },
				fadeEffect: { crossFade: true },
				// autoplay: SwiperCarousel.data('autoplay') || false,
				autoplay: {
					delay: 2000,
				},
				//  autoplay: {
				//   delay: 1000,
				// },
				breakpoints: breakpoints
			});
		});
	}
})(jQuery);
